export default __webpack_public_path__ + "static/media/Investor-Presentation-Q1FY27.19b7f3a1.pdf";